<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- <div class="page-content__header-description">Performance</div> -->
      <div class="row">
        <div class="col-md-12">
          <!-- <div class="page-content__header-description" style="display: flex;">
        <h2 style="flex: 1;">Device Performance</h2>
          </div>-->
          <!-- <el-tabs v-model="activeTab">
          <el-tab-pane label="IoT Performance" name="performance">-->
          <iot-performance />
          <!-- <div v-else> Loading</div>
            </el-tab-pane>

          </el-tabs>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IotPerformance from "../performance";
import GeoDistro from "../performance/geoDistro";
import RightBar from "../rightBar";
import { Iconnav, IconnavItem } from "vuikit";
import { Tabs, TabPane, Switch } from "element-ui";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
Vue.use(Tabs);
Vue.use(TabPane);
export default {
  name: "Performance",
  components: {
    IotPerformance,
    GeoDistro,
    "vk-iconnav": Iconnav,
    "vk-iconnav-item": IconnavItem
  },
  data() {
    return {
      switchOption: true,
      activeTab: "performance",
      value: "Live"
    };
  },
  computed: {
    ...mapGetters(["DeviceList", "getUserByDevice", "getUserSession"])
  },
  methods: {},
  mounted() {
    // if (!this.$can("read", "installation")) {
    //   this.$router.push({
    //     path: "/",
    //   });
    //   return;
    // }
  }
};
</script>

<style lang="scss" scoped>
#iot-list:empty {
  margin: auto;
  width: 100%;
  height: 600px;
  /* change height to see repeat-y behavior */

  background-image: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0.5) 80%
    ),
    linear-gradient(rgb(233, 233, 233) 6px, transparent 0),
    linear-gradient(rgb(233, 233, 233) 6px, transparent 0),
    linear-gradient(rgb(233, 233, 233) 6px, transparent 0),
    linear-gradient(rgb(233, 233, 233) 6px, transparent 0);

  background-repeat: repeat-y;

  background-size:
    // 100px 200px, /* circle */ 150px 50px,
    /* highlight */ 150px
      50px,
    150px 50px, 150px 50px, 150px 50px;

  background-position:
    // 0 0, /* circle */ 20px 50px,
    /* highlight */ 250px
      50px,
    450px 50px, 650px 50px, 850px 50px;

  animation: shine 1s infinite;
}

@keyframes shine {
  to {
    background-position:
      // 0 0, 100% 50px,
      /* move highlight to right */ 250px
        50px,
      450px 50px, 650px 50px, 850px 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/performance.vue